import { useTranslation } from 'react-i18next';
import { DivisionsTable } from '../../../components/Divisions/DivisionsTable';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';

export const SetupDivisions = () => {
  const { t } = useTranslation();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()} title={t('divisions.default')}>
      <DivisionsTable />
    </Page>
  );
};
